import { render, staticRenderFns } from "./slide.vue?vue&type=template&id=6f598f0c&scoped=true&"
import script from "./slide.vue?vue&type=script&lang=js&"
export * from "./slide.vue?vue&type=script&lang=js&"
import style0 from "./slide.vue?vue&type=style&index=0&id=6f598f0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f598f0c",
  null
  
)

export default component.exports